import "./NGrams.scss";
import BarChart from "../BarChart/BarChart";

const NGrams = ({ barChartData, postsData }) => {
  return (
    <section className="ngrams">
      <div className="ngrams__top">
        <BarChart
          barChartData={Object.values(postsData.totalTimeOfDay)}
          horizontal={false}
          title={"Top Posts by Time of Day"}
          xLabel={"Time of Day"}
          yLabel={`Percentage of Total`}
          seriesName="Percentage of Total"
          topN={24}
        />
        <BarChart
          barChartData={barChartData.uniGrams}
          horizontal={true}
          title={`Most Common Words in Post Titles`}
          xLabel={"Word Frequency"}
          yLabel={"Word"}
          seriesName="Word count"
          topN={10}
        />
      </div>
      <div className="ngrams__bottom">
        <BarChart
          barChartData={barChartData.biGrams}
          horizontal={true}
          title={`Most Common BiGrams in Post Titles`}
          xLabel={"BiGram Frequency"}
          yLabel={"BiGram"}
          seriesName="Word count"
          topN={10}
        />
        <BarChart
          barChartData={barChartData.triGrams}
          horizontal={true}
          title={`Most Common TriGrams in Post Titles`}
          xLabel={"TriGram Frequency"}
          yLabel={"TriGram"}
          seriesName="Word count"
          topN={10}
        />
      </div>
    </section>
  );
};

export default NGrams;
